function isElementReference(element) {
  return !("props" in element);
}
const ControlDataTypeKey = "@@makeswift/type";
export {
  ControlDataTypeKey,
  isElementReference
};
//# sourceMappingURL=types.js.map